import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { PaperOnlyIcon } from "../assets/icons";

export default function ReportInputEmptyState() {
  return (
    <View style={styles.emptyState}>
      <View style={styles.iconCircle}>
        <PaperOnlyIcon width={24} height={24} customColor="#FFFFFF" />
      </View>
      <Text style={styles.emptyTitle}>Belum Ada Formulir Input Data</Text>
      <Text style={styles.emptyDescription}>
        Mohon maaf, saat ini belum ada Formulir Input Data yang perlu kamu isi.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  emptyState: { flex: 1, alignItems: "center", justifyContent: "center", paddingHorizontal: 24, paddingBottom: 64 },
  iconCircle: { width: 70, height: 70, borderRadius: 35, backgroundColor: "#5423B5", alignItems: "center", justifyContent: "center" },
  emptyTitle: { marginTop: 20, color: "#111111", fontFamily: "Archivo-Bold", fontSize: 15, textAlign: "center" },
  emptyDescription: { maxWidth: 320, marginTop: 10, color: "#111111", fontFamily: "Archivo-Regular", fontSize: 14, lineHeight: 20, textAlign: "center" },
});